import { inject, Pipe, PipeTransform } from '@angular/core';

import { SettingsState } from '@core/settings';

import { User } from '../users.entity';
import { AuthState } from '../auth.state';

export enum UserAvatarSize {
  SMALL = 'small',
  MEDIUM = 'medium',
  FULL = 'full'
}

const DEFAULT_PHOTO_URL = '/assets/images/no-photo.webp';

@Pipe({
  name: 'userAvatar'
})
export class UserAvatarPipe implements PipeTransform {
  private readonly authState = inject(AuthState);
  private readonly settingsState = inject(SettingsState);

  transform(user: User, size: UserAvatarSize = UserAvatarSize.MEDIUM, noCustomPhoto = false): string {
    const streamerMode = this.settingsState.streamerMode();
    const animationsDisabled = this.settingsState.disableAnimations();
    const loggedUserId = this.authState.user()?.id;

    if(streamerMode && loggedUserId !== user.id) {
      return DEFAULT_PHOTO_URL;
    }

    if(!noCustomPhoto && !animationsDisabled && user.customPhoto) {
      return user.customPhoto;
    }

    if(!user.photoUrl) {
      return DEFAULT_PHOTO_URL;
    }

    if(size === UserAvatarSize.FULL) {
      return user.photoUrl;
    }

    return user.photoUrl.replace('_full', `_${ size }`);
  }
}
